import { ServiceType } from '@/creditflowresearch/domain/ServiceType';
import React from 'react';

export default {
  [ServiceType.ENTERPRISE]: {
    titleModal: <>Market Data<br />Enterprise Pricing</>,
    titleForm: 'Request a Quote',
    isCaptcha: true,
  },
  [ServiceType.API]: {
    titleModal: <>Market Data<br />API Integration</>,
    titleForm: 'Request a Quote',
    isCaptcha: true,
    isSolutionsSelect: true,
  },
  [ServiceType.UPGRADE_PRICING_ACCESS]: {
    titleModal: <>Upgrade your<br />market data access</>,
    titleForm: 'Request a Quote',
    isCaptcha: true,
    isSolutionsSelect: true,
    commentPlaceholder: 'Please provide your desired credit product (ABS and/or Corporate Bonds) for upgrade, ' +
                        'along with any other applicable details...',
  },
  [ServiceType.BONDSCREENER_EXPORT]: {
    titleModal: <>US ABS Market<br />Data Export</>,
    titleForm: 'Market Data Export',
    isCaptcha: false,
  },
};
